module.exports = __webpack_public_path__ + "img/logo-text-white.f0698274.png";